(function ($, Drupal, settings) {
	"use strict";
	$('.header-hamburger').click(function(){
		$(this).toggleClass('active');
		$('.header-menu, html, body').toggleClass('active');
	});

	$('body').on('mouseup', function(e){
		var div = $('.header-menu, .header-hamburger');
		if (!div.is(e.target) && div.has(e.target).length === 0) {
			$('html, body').removeClass('active');
			$(div).removeClass('active');
		}
	});

	$('.header-menu .sub-menu a').click(function(){
		$('html, body, .header-menu, .header-hamburger').removeClass('active');
	});

	$('.references-btn-show').click(function(){
		$(this).parents('.references').toggleClass('active');
	});

	$('.references ol li').each(function(){
		$(this).wrapInner('<p></p>');
	});

  // click the "play video" button in home page herospace
	$('.front .hero-block .btn-hover').click(function(e){
		e.preventDefault();
		$('#video').dialog('open');
	});

  // jQuery Dialog - init modal
	$('#video, [id^="resources-video"]').dialog({
		autoOpen: false,
		dialogClass: 'modal-video',
		open: function() {
			$('body').addClass('active');
		},
		close: function() {
			$('body').removeClass('active');
			var elem = $(this).find('iframe'),
					video = elem.attr('src');
			elem.attr('src', '');
			elem.attr('src', video);
		}
	});

	$('.video-btn').click(function(e){
		e.preventDefault();
		var video = $(this).data('video');
		$('#' + video).dialog('open');
	});

  // Accordion
	$('.accordion-items').accordion({
		collapsible: true,
		active: false,
		heightStyle: 'content'
	});

  // add data attributes to accordion arrows
  $('.accordion-items .accordion-item-title').each(function (){
    this.querySelector('.ui-icon').dataset.eventCategory = this.dataset.eventCategory;
    this.querySelector('.ui-icon').dataset.eventAction = this.dataset.eventAction;
    this.querySelector('.ui-icon').dataset.eventLabel = this.dataset.eventLabel;
  });

	$('a:not(.popup-btn):not([href^="tel:"]):not([href^="mailto:"])').click(function(e){
		var href = $(this)[0]['href'],
				url = window.location.host;
		if (!href.includes(url)) {
			e.preventDefault();
			$('.popup, body').addClass('active');
			$('.popup-btn').attr('href', href);
		}
	});

	$('.popup .close, .popup .btn-white').click(function(e){
		e.preventDefault();
		$('.popup, body').removeClass('active');
		var elem = $(this).parents('.modal-video').find('iframe'),
				video = elem.attr('src');
		elem.attr('src', '');
		elem.attr('src', video);
	});

	$('.popup-btn').click(function(){
		$('.popup, body').removeClass('active');
	});

	if ($(window).width() < 1000) {
		$('.header-menu li.has-sub-menu > a').click(function(e){
			e.preventDefault();
		});
		$('.header-menu li.has-sub-menu').click(function(){
			$(this).toggleClass('menu-active');
			$('.header-menu').toggleClass('sub-menu-active');
		});
	} else {
		$('.header-menu li.has-sub-menu').hover(function(){
			$('.header-menu li.has-sub-menu').not($(this)).removeClass('menu-active');
			$(this).toggleClass('menu-active');
		});
	}

	jQuery('a[href*="#"]:not(.scroll-false)').on('click', function() {
		var href = '#' + jQuery(this).attr('href').split('#')[1];
		jQuery('html, body').animate({
			scrollTop: jQuery(href).offset().top - 150
		});
		return false;
	});

	var target = window.location.hash;

	if (target != ''){
		var $target = jQuery(target);
		jQuery('html, body').stop().animate({
			'scrollTop': $target.offset().top - 150
		});
	}

	if ($(window).width() < 760) {
		$('.front .hero-block .desc, .front .hero-block .btn-hover').insertAfter('.front .hero-block').wrapAll('<div class="container"><div class="hero-block-desc"></div></div>');
	}

	cssVars({
		include: '[href*=korsuva_eu]'
	});

})(jQuery, Drupal, drupalSettings);
